import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const ComprehensiveValuation = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default ComprehensiveValuation